<template>
    <v-card flat tile :loading="loading">
      <v-row no-gutters>
        <v-col cols="3">
          <v-navigation-drawer width="100%" permanent
            min-height="calc(100vh - 190px)" height="100vh">
            <template v-slot:prepend>
              <v-list :disabled="!isEditable" class="pb-0">
                <v-list-item>
                  <v-list-item-subtitle class="subtitle-2 black--text text-uppercase">
                    <div class="d-flex align-center">
                      {{ title }} ({{ results.length }})
                      <v-btn small icon color="accent"
                        @click="init" title="Refresh">
                        <v-icon small dark class="ml-1">mdi-sync</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn small
                        @click="onNewTask"
                        depressed
                      >
                        <v-icon small dark class="mr-1">mdi-plus</v-icon> Add
                      </v-btn>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </template>
            <v-list two-line :disabled="!isEditable" v-if="results.length !== 0">
              <template v-for="(item, index) in results">
                <v-divider :key="index"></v-divider>
                <issue-card :issue="item" :key="item.id"></issue-card>
              </template>
            </v-list>
            <v-list v-else>
              <v-divider></v-divider>
            </v-list>
          </v-navigation-drawer>
        </v-col>
        <v-col>
          <router-view :key="$route.params.issueId"
            :project="project"
            @addTask="onNewTask"
            @taskUpdated="onTaskUpdated"></router-view>
        </v-col>
      </v-row>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import types, { BUS } from '@/store/types';
import { GlobalEvents } from '@/event-bus';
import IssueCard from './IssueCard.vue';

export default {
  name: 'project-issues-page',
  components: {
    IssueCard,
  },
  props: ['project', 'isEditable'],
  data: () => ({
    title: 'Tasks',
    results: [],
    dialog: false,
    formData: undefined,
    loading: false,
  }),
  computed: {
    ...mapGetters('routes', ['projectTabItems']),
    ...mapState('routes', {
      projectRoute: state => state.PROJECT_INFO,
    }),
    projectId() { return this.$route.params.projectId; },
    extraData() {
      return {
        projectId: this.projectId,
        projectName: this.project.name,
      };
    },
  },
  methods: {
    ...mapActions('db', {
      fetchResults: types.GET_ISSUES,
    }),
    onNewTask() {
      GlobalEvents.$emit(BUS.OPEN_MANAGE_ISSUE, {
        formData: undefined,
        extraData: {
          ...this.extraData,
        },
      });
    },
    loadResults() {
      this.loading = true;
      this.fetchResults(this.projectId)
        .then((results) => {
          this.results = Array.isArray(results) ? results : [];
        }).catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onTaskAdded(payload) {
      this.results.unshift(payload);
    },
    onTaskUpdated(payload) {
      this.results = this.results.map(item => ((item.id === payload.id) ? {
        ...item,
        ...payload,
      } : item));
    },
    init() {
      this.loadResults();
    },
  },
  created() {
    this.init();
  },

  mounted() {
    this.$root.$on('taskAdded', this.onTaskAdded);
  },

  beforeDestroy() {
    this.$root.$off('taskAdded');
  },
};
</script>
